import { useEffect, useState } from 'react';
import { Stack, Typography, Box, Paper } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { CaseAnalyticsChart } from './features/CaseAnalyticsChart/CaseAnalyticsChart';
import { CategoryAnalyticsChart } from './features/CategoryAnalyticsChart/CategoryAnalyticsChart';
import { CaseAnalyticsQueueChart } from './features';
import { useAnalyticsSyncDate } from "../../context/analytics-sync-date.context";
import { CaseAnalyticsDateRangeFilter } from './components/CaseAnalyticsDateRangeFilter';

export const CaseAnalyticsView = (props) => {
  const [fromDate, setFromDate] = useState(() => dayjs().startOf('month'));
  const [toDate, setToDate] = useState(() => dayjs().endOf('month'));
  const { fromDate: syncedFromDate, toDate: syncedToDate, enableDateSync } = useAnalyticsSyncDate();

  useEffect(() => {
    console.log('CaseAnalyticsView sync date context', {
      fromDate: syncedFromDate,
      toDate: syncedToDate,
      enableDateSync,
    });


    // If date sync is enabled, update local state to match synced dates
    if (enableDateSync) {
      if (syncedFromDate) {
        setFromDate(dayjs(syncedFromDate));
      }
      if (syncedToDate) {
        setToDate(dayjs(syncedToDate));
      }
    }

  }, [syncedFromDate, syncedToDate, enableDateSync]);

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate ? dayjs(newDate) : null);
  };

  const handleToDateChange = (newDate) => {
    setToDate(newDate ? dayjs(newDate) : null);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        p: 3,
        border: '2px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#fafafa',
        overflowX: 'auto'
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3} sx={{ flexGrow: 1 }}>
          <Typography variant="h4" gutterBottom>
            Case Analytics
          </Typography>

          <Paper elevation={2} sx={{ p: 3, mb: 0, border: '1px solid #d0d0d0' }}>

            <Typography variant="body2" color="textSecondary" sx={{ mt: 1, p: 1, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              Note: This analytics is based on the 'dateReceived' field.
            </Typography>
          </Paper>

          <CaseAnalyticsDateRangeFilter
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={handleFromDateChange}
            onToChange={handleToDateChange}
          />

          {/* Case Analytics Component - New Registration vs Delivered */}
          <CaseAnalyticsChart
            fromDate={fromDate}
            toDate={toDate}
            onFromDateChange={handleFromDateChange}
            onToDateChange={handleToDateChange}
          />

          {/* Category Analytics Component - 7-Category Chart */}
          <CategoryAnalyticsChart
            fromDate={fromDate}
            toDate={toDate}
            onFromDateChange={handleFromDateChange}
            onToDateChange={handleToDateChange}
          />

          {/* Case Analytics Queue Component */}
          <CaseAnalyticsQueueChart
            fromDate={fromDate}
            toDate={toDate}
            onFromDateChange={handleFromDateChange}
            onToDateChange={handleToDateChange}
          />
        </Stack>
      </LocalizationProvider>
    </Box>
  );
};

// Keep legacy export for backward compatibility  
export const CaseAnalytics = CaseAnalyticsView;
